// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0e72c8d1","703":"9795ce57","787":"a53d3a73"}[chunkId] + ".chunk.js";
};